import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";

import { SharedModule } from "@app/shared/shared.module";

import { AdmininstrationCleanupManagementRoutingModule } from "@app/administration/cleanup-management/administration-cleanup-management-routing.module";
import { AutomationCleanupListComponent } from "@app/administration/cleanup-management/automation-cleanup-management/automation-cleanup-management-list/automation-cleanup-list.component";
import { AutomationCleanupFormComponent } from "@app/administration/cleanup-management/automation-cleanup-management/automation-cleanup-management-form/automation-cleanup-form.component";
import { AutomationCleanupManagementLayoutComponent } from "@app/administration/cleanup-management/automation-cleanup-management/automation-cleanup-management-layout/automation-cleanup-management-layout.component";
import { ManualCleanupManagementLayoutComponent } from "@app/administration/cleanup-management/manual-cleanup-management/manual-cleanup-management-layout/manual-cleanup-management-layout.component";
import { ManualCleanupFormComponent } from "@app/administration/cleanup-management/manual-cleanup-management/manual-cleanup-management-form/manual-cleanup-form.component";
import { DataCleanupLogLayoutComponent } from "@app/administration/cleanup-management/data-cleanup-log-layout/data-cleanup-log-layout.component";
import { DataCleanupLogFormComponent } from "@app/administration/cleanup-management/data-cleanup-log-form/data-cleanup-log-form.component";

import { AdminGuard } from "@app/core/guards/admin.guard";

const directives: any[] = [
  AutomationCleanupFormComponent,
  AutomationCleanupListComponent,
  AutomationCleanupManagementLayoutComponent,
  ManualCleanupManagementLayoutComponent,
  ManualCleanupFormComponent,
  DataCleanupLogLayoutComponent,
  DataCleanupLogFormComponent
];

@NgModule({
  imports: [
    AdmininstrationCleanupManagementRoutingModule,
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgSelectModule,
    SharedModule
  ],
  declarations: directives,
  providers: [ AdminGuard ]
})
export class AdministrationCleanupModule { }
